<template>
    <div class="pp-lottery-countdown" :class="countdownClass">
        <DsIcon v-if="isMobile" :name="LotteryUtils.isQuickLottery(lottery) ? 'quick-lottery-thin' : 'time-thin'" />
        <div class="pp-lottery-countdown__timer" v-html="formattedTime"></div>
    </div>
</template>

<script lang="ts" setup>
import { onMounted, onUnmounted, watch } from "vue";
import { useLotteryCountdownManager } from "../composables/use-lottery-countdown-manager";
import { Lottery } from "@sazka/lotteries/js/models/lottery";
import { useProductPageLotteryCountdowns } from "./shared/composables/use-product-page-lottery-countdowns";
import DsIcon from "@sazka/design-system/src/icon/ds-icon.vue";
import { LotteryUtils } from "@sazka/lotteries/js/utils/lottery-utils";
import { usePageVisibility } from "@sazka/utils/composables/use-page-visibility";

const props = defineProps<{
    lottery: Lottery;
    isMobile: boolean;
}>();

const countdownClass = props.isMobile ? "pp-lottery-countdown--mobile" : "pp-lottery-countdown--desktop";

const { formatLotteryCountdown, startCountdown, killCountdown, formattedTime } = useProductPageLotteryCountdowns(
    props.lottery
);
const lotteries = [props.lottery];

const { countdowns, unsubscribe, initialLoadPromise } = useLotteryCountdownManager(lotteries);

const initCountdown = async () => {
    await initialLoadPromise;
    formatLotteryCountdown(countdowns.value[0].secondsRemaining, props.isMobile);
    startCountdown(() => formatLotteryCountdown(countdowns.value[0].secondsRemaining, props.isMobile));
};

const { isDocumentVisible } = usePageVisibility();
watch(isDocumentVisible, (value) => {
    if (value) {
        initCountdown();
    } else {
        killCountdown();
    }
});

onMounted(async () => {
    await initCountdown();
});

onUnmounted(() => {
    unsubscribe();
    killCountdown();
});
</script>
